module.exports = __webpack_public_path__ + "assets/img/1104ad14d3be26e0ced40697bc61f188.png";